import { useTranslation } from 'react-i18next'
import { Alert, AlertDescription } from '@/components/ui/alert'
import { Button } from '@/components/ui/button'

type OnboardingMachineCharacteristicsExtractionIntroStepProps = {
  extractionError: string | null
  isTypeBGenerateBlocked?: boolean
  onBeginMachineCharacteristicsExtraction: () => void
}

export function OnboardingMachineCharacteristicsExtractionIntroStep({
  extractionError,
  isTypeBGenerateBlocked = false,
  onBeginMachineCharacteristicsExtraction,
}: OnboardingMachineCharacteristicsExtractionIntroStepProps) {
  const { t } = useTranslation('machineryDirectiveCompliance')
  const beginButtonDisabledTooltip = isTypeBGenerateBlocked
    ? t('onboarding.machineCharacteristicsExtraction.waitForEPlanMessage')
    : undefined

  return (
    <div className='w-full max-w-lg space-y-4'>
      <h2 className='text-lg font-semibold tracking-tight'>
        {t('onboarding.machineCharacteristicsExtraction.heading')}
      </h2>
      {isTypeBGenerateBlocked ? (
        <Alert variant='warning'>
          <AlertDescription>
            {t('onboarding.machineCharacteristicsExtraction.waitForEPlanMessage')}
          </AlertDescription>
        </Alert>
      ) : null}
      <p className='leading-relaxed text-muted-foreground'>
        {t('onboarding.machineCharacteristicsExtraction.introDescription')}
      </p>
      {extractionError ? (
        <p className='text-sm text-destructive' role='alert'>
          {extractionError}
        </p>
      ) : null}
      <div className='flex justify-end'>
        <Button
          onClick={onBeginMachineCharacteristicsExtraction}
          disabled={isTypeBGenerateBlocked}
          title={beginButtonDisabledTooltip}
        >
          {t('onboarding.machineCharacteristicsExtraction.beginButton')}
        </Button>
      </div>
    </div>
  )
}
